"use strict";
/**
 * Provide access to
 * {@link UpdateConstraint UpdateConstraint},
 * {@link UpdateConstraintFactory UpdateConstraintFactory},
 * {@link PartialJSON PartialJSON},
 * {@link TopicCreationResult TopicCreationResult}, and
 * {@link UpdateStream UpdateStream}.
 *
 * @module diffusion.topicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicUpdateNamespace = exports.TopicCreationResult = void 0;
var update_constraint_1 = require("./update-constraint");
/* aeslint-disable @typescript-eslint/naming-convention */
/**
 * Result indicating whether the operation caused a topic to be created or if
 * it already existed.
 *
 * @since 6.2
 */
var TopicCreationResult;
(function (TopicCreationResult) {
    /**
     * A new topic was created.
     */
    TopicCreationResult[TopicCreationResult["CREATED"] = 1] = "CREATED";
    /**
     * A topic with the same specification already exists.
     */
    TopicCreationResult[TopicCreationResult["EXISTS"] = 2] = "EXISTS";
})(TopicCreationResult = exports.TopicCreationResult || (exports.TopicCreationResult = {}));
// eslint-disable-next-line @typescript-eslint/no-redeclare,@typescript-eslint/naming-convention
exports.TopicUpdateNamespace = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    TopicCreationResult: TopicCreationResult,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    UpdateConstraintOperator: update_constraint_1.UpdateConstraintOperator
};
